import { Action } from '@ngrx/store';
import { PatientWorkflow } from '../patient-workflow/patient-workflow.model';

export enum PatientWorkflowWsActionTypes {
  LocalCreatePatientWorkflowSuccessWs = '[PatientWorkflow WS] Local Create PatientWorkflows Success',
  LocalCreatePatientWorkflowFailureWs = '[PatientWorkflow WS] Local Create PatientWorkflows Failure',
  LocalUpdatePatientWorkflowSuccessWs = '[PatientWorkflow WS] Local Update PatientWorkflows Success',
  LocalUpdatePatientWorkflowFailureWs = '[PatientWorkflow WS] Local Update PatientWorkflows Failure',
  LocalRemovePatientWorkflowSuccessWs = '[PatientWorkflow WS] Local Remove PatientWorkflows Success',
  LocalRemovePatientWorkflowFailureWs = '[PatientWorkflow WS] Local Remove PatientWorkflows Failure',
  LocalCompletePatientWorkflowSuccessWs = '[PatientWorkflow WS] Local Complete PatientWorkflows Success',
  LocalCompletePatientWorkflowFailureWs = '[PatientWorkflow WS] Local Complete PatientWorkflows Failure',
  GlobalCreatePatientWorkflowSuccessWs = '[PatientWorkflow WS] Global Create PatientWorkflows Success',
  GlobalUpdatePatientWorkflowSuccessWs = '[PatientWorkflow WS] Global Update PatientWorkflows Success',
  GlobalRemovePatientWorkflowSuccessWs = '[PatientWorkflow WS] Global Remove PatientWorkflows Success',
  GlobalCompletePatientWorkflowSuccessWs = '[PatientWorkflow WS] Global Complete PatientWorkflows Success',
}

export class LocalCreatePatientWorkflowSuccessWs implements Action {
  readonly type = PatientWorkflowWsActionTypes.LocalCreatePatientWorkflowSuccessWs;

  constructor(public payload: { id: string; correlation_id: string }) {}
}

export class LocalCreatePatientWorkflowFailureWs implements Action {
  readonly type = PatientWorkflowWsActionTypes.LocalCreatePatientWorkflowFailureWs;

  constructor(public payload: { correlation_id: string; message: string }) {}
}

export class LocalUpdatePatientWorkflowSuccessWs implements Action {
  readonly type = PatientWorkflowWsActionTypes.LocalUpdatePatientWorkflowSuccessWs;

  constructor(public payload: { id: string; correlation_id: string }) {}
}

export class LocalUpdatePatientWorkflowFailureWs implements Action {
  readonly type = PatientWorkflowWsActionTypes.LocalUpdatePatientWorkflowFailureWs;

  constructor(public payload: { correlation_id: string; message: string }) {}
}

export class LocalRemovePatientWorkflowSuccessWs implements Action {
  readonly type = PatientWorkflowWsActionTypes.LocalRemovePatientWorkflowSuccessWs;

  constructor(public payload: { correlation_id: string }) {}
}

export class LocalRemovePatientWorkflowFailureWs implements Action {
  readonly type = PatientWorkflowWsActionTypes.LocalRemovePatientWorkflowFailureWs;

  constructor(public payload: { correlation_id: string; message: string }) {}
}

export class LocalCompletePatientWorkflowSuccessWs implements Action {
  readonly type = PatientWorkflowWsActionTypes.LocalCompletePatientWorkflowSuccessWs;

  constructor(public payload: { correlation_id: string }) {}
}

export class LocalCompletePatientWorkflowFailureWs implements Action {
  readonly type = PatientWorkflowWsActionTypes.LocalCompletePatientWorkflowFailureWs;

  constructor(public payload: { correlation_id: string; message: string }) {}
}

export class GlobalCreatePatientWorkflowSuccessWs implements Action {
  readonly type = PatientWorkflowWsActionTypes.GlobalCreatePatientWorkflowSuccessWs;
  constructor(public payload: PatientWorkflow) {}
}

export class GlobalUpdatePatientWorkflowSuccessWs implements Action {
  readonly type = PatientWorkflowWsActionTypes.GlobalUpdatePatientWorkflowSuccessWs;
  constructor(public payload: PatientWorkflow) {}
}

export class GlobalRemovePatientWorkflowSuccessWs implements Action {
  readonly type = PatientWorkflowWsActionTypes.GlobalRemovePatientWorkflowSuccessWs;
  constructor(public payload: PatientWorkflow['id']) {}
}

export class GlobalCompletePatientWorkflowSuccessWs implements Action {
  readonly type = PatientWorkflowWsActionTypes.GlobalCompletePatientWorkflowSuccessWs;
  constructor(public payload: PatientWorkflow['id']) {}
}

export type PatientWorkflowWsActions =
  | LocalCreatePatientWorkflowSuccessWs
  | LocalCreatePatientWorkflowFailureWs
  | LocalUpdatePatientWorkflowSuccessWs
  | LocalUpdatePatientWorkflowFailureWs
  | LocalRemovePatientWorkflowSuccessWs
  | LocalRemovePatientWorkflowFailureWs
  | LocalCompletePatientWorkflowSuccessWs
  | LocalCompletePatientWorkflowFailureWs
  | GlobalCreatePatientWorkflowSuccessWs
  | GlobalUpdatePatientWorkflowSuccessWs
  | GlobalRemovePatientWorkflowSuccessWs
  | GlobalCompletePatientWorkflowSuccessWs;
